import moment from 'moment'
import {zeroPadNumber} from '../helpers'

export const dateTimeFormat = (dateTime) => {
  const date = moment(dateTime)
  if (date.isSame(moment(), 'day')) return date.format('hh:mm a')
  if (date.isSame(moment(), 'week')) return date.format('dd hh:mm a')
  if (date.isSame(moment(), 'month')) return date.format('DD hh:mm a')
  if (date.isSame(moment(), 'year')) return date.format('MM/DD hh:mm a')
  return date.format('YYYY/MM/DD hh:mm a')
}

export const meetingStatus = (meeting) => {
  if (moment() > moment(meeting.end_at)) return '終了'
  const participant = meeting.owner_participant
  if (participant.status === 1) return '申請中'
  if (participant.status === 2) return '確定'
  if (participant.status === 3) return '取り消し'
}

export function meetingTimeDisplay (startAt, endAt) {
  startAt = moment(startAt)
  endAt = moment(endAt)
  if (startAt.year() !== endAt.year()) {
    return `${startAt.year()}/${zeroPadNumber(startAt.month() + 1)}/${zeroPadNumber(startAt.date())} ${startAt.format('HH:mm')} ~` +
           ` ${endAt.year()}/${zeroPadNumber(endAt.month() + 1)}/${zeroPadNumber(endAt.date())} ${endAt.format('HH:mm')}`
  }
  return `${zeroPadNumber(startAt.month() + 1)}/` +
         `${zeroPadNumber(startAt.date())} ${startAt.hour()}:` +
         `${zeroPadNumber(startAt.minute())}~` +
         `${endAt.hour()}:${zeroPadNumber(endAt.minute())}`
}

export function dayOfWeekLabel (day) {
  if (day === 0) return '日'
  if (day === 1) return '月'
  if (day === 2) return '火'
  if (day === 3) return '水'
  if (day === 4) return '木'
  if (day === 5) return '金'
  if (day === 6) return '土'

  return day
}



// WEBPACK FOOTER //
// ./src/filters/index.js